"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBody = void 0;
var DialogBody_1 = __importDefault(require("./DialogBody"));
exports.DialogBody = DialogBody_1.default;
exports.default = DialogBody_1.default;
//# sourceMappingURL=index.js.map